//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LinsesTitle from '~/components/linses/LinsesTitle'
import LinsesDescriptionBlock from '~/components/linses/main-page/LinsesDescriptionBlock'
import SPage from '~/components/page/SPage.vue'

export default {
  name: 'index',
  components: {
    LinsesDescriptionBlock,
    LinsesTitle,
    SPage
  },
  head () {
    const meta = [
      {
        hid: 'metadescription',
        name: 'description',
        content: this.seoDescription || '',
      },
    ]

    return {
      title: this.seoTitle || '',
      meta: meta,
    }
  },
  async asyncData ({
    $api,
    error
  }) {
    const request = await $api.agent.transport.get('competitors/category')

    return {
      linsesList: request?.data || [],
    }
  },
  computed: {
    seoTitle () {
      const city = this.$store.getters['appState/config']

      return `Линзы ODV Superclean в ${city?.city?.model?.name}`
    },
    seoDescription () {
      return 'Линзы ODV Superclean производятся по технологии FreeForm , которая позволяет применять более точные методики расчета линзы и получать поверхности «свободной формы» с очень высокой точностью в пределах 0,01D'
    },
    breadcrumbs () {
      return [{
        title: 'Главная',
        path: '/'
      }, {
        title: 'Линзы для очков',
        path: '/lenses'
      }]
    },

    cmsPageId: function () {
      return Number.parseFloat(this.$store.state.appState?.vars?.['Шаблон для сравнения линз'] || '0')
    },
  },
}
